import React, { useEffect, useState } from 'react';
import { MainRouter } from './navigation/main.router';
import { NavigationOutlet } from './navigation/navigation.outlet';
import { useMatchScreenWidth } from '@keplerco/core';
import { AppLoaderLayer } from './components/loading-handling/loader-layers/app-loader-layer/app-loader-layer';
import { GlobalProvider, useGlobalState } from './global-state';
import { Dots } from './components/dots.background';

function AppContent() {
  
  const isTablet = useMatchScreenWidth('tablet');
  const isMobile = useMatchScreenWidth('mobile');
  const [mainPaddingLeft, setMainPaddingLeft] = useState<number>(0);
  const { value: mayViewSideNav } = useGlobalState('mayViewSideNav');
  const { value: sideNavVisible } = useGlobalState('sideNavVisible');
  const { value: sideNavCollapsed } = useGlobalState('sideNavCollapsed');

  useEffect(() => {
    if (isMobile || isTablet) return void setMainPaddingLeft(0);
    if (!mayViewSideNav) return void setMainPaddingLeft(0);
    if (!sideNavVisible) return void setMainPaddingLeft(0);
    if (sideNavCollapsed) return void setMainPaddingLeft(90);
    setMainPaddingLeft(245);
  }, [mayViewSideNav, sideNavVisible, sideNavCollapsed, isTablet, isMobile]);

  return (
    <main style={{ paddingLeft: mainPaddingLeft }}>
      <NavigationOutlet isMobile={isMobile} isTablet={isTablet} />
      <Dots show={true} />
      <MainRouter />
      <AppLoaderLayer />
    </main>
  );
}

function App() {
  return (
    <GlobalProvider>
      <AppContent />
    </GlobalProvider>
  );
}

export default App;
